<template>
	<div class="cassie-vertical-md mt-1">
		<FilterBar
			hide-search-query-filter
			hide-brand-filter
			@clearFilters="domainFilter = null"
		>
			<template #after-filters>
				<Dropdown
					v-model="domainFilter"
					:items="trackerDomainItems"
					label="Domain"
					custom-sort
				/>
			</template>
		</FilterBar>
		<SectionCard>
			<template #title>
				Trackers
			</template>
			<template #subtitle>
				All trackers are grouped by domain, click to expand
			</template>
			<template #body>
				<v-expansion-panels>
					<v-expansion-panel
						v-for="(trackerDomain, index) in filteredTrackerDomains"
						:key="index"
						@click="openTrackerDetails($event, trackerDomain.domain)"
					>
						<v-expansion-panel-header>
							<v-row>
								<v-col cols="10">
									<span class="font-weight-bold mr-2">
										{{ trackerDomain.domain }} :
									</span>
									{{ trackerDomain.count }}
								</v-col>
							</v-row>
						</v-expansion-panel-header>
						<v-expansion-panel-content v-if="trackersByDomain[trackerDomain.domain]">
							<DataTable
								:headers="tableHeaders"
								:items="trackersByDomain[trackerDomain.domain].trackers"
								:options.sync="trackersByDomain[trackerDomain.domain].options"
								:server-items-length="trackersByDomain[trackerDomain.domain].totalTrackers"
								@update:options="updateOptions($event, trackerDomain.domain)"
							>
								<template #item.url="{ item }">
									{{ item.url }}
								</template>
							</DataTable>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</template>
		</SectionCard>
	</div>
</template>

<script>
import FilterBar from '../../../../../../../shared/components/filter-bar.vue'
import Dropdown from '../../../../../../../shared/components/dropdown.vue'
import SectionCard from '../../../../../../../shared/components/section-card.vue'
import DataTable from '../../../../../../../shared/components/data-table.vue'
import { getTrackerOverview, getTrackerLookup } from '../../../../../../../shared/utils/api/site-scanner.js'
export default {
	components: {
		FilterBar,
		Dropdown,
		SectionCard,
		DataTable
	},
	props: {
		scanGuid: String,
		userCanUseSiteScanner: Boolean
	},
	data () {
		return {
			trackerDomains: [],
			trackersByDomain: {},
			openDomain: null,
			totalUrls: 0,
			domainFilter: null
		}
	},
	computed: {
		tableHeaders () {
			return [
				{ text: 'URL', value: 'url', width: '85%' },
				{ text: 'Tracker Type', value: 'trackerType', width: '15%' }
			]
		},
		trackerDomainItems () {
			const domainItems = [
				{ value: null, text: 'View All' },
				...this.trackerDomains.map(({ domain }) => ({
					value: domain,
					text: domain
				})).sort((a, b) => a.text.localeCompare(b.text))
			]
			return domainItems
		},
		filteredTrackerDomains () {
			return this.trackerDomains.filter(({ domain }) => {
				let check = true
				if (this.domainFilter) check = domain.toLowerCase() === this.domainFilter.toLowerCase()
				return check
			})
		}
	},
	async created () {
		await this.getTrackerOverview()
	},
	methods: {
		async getTrackerOverview () {
			const { data } = await getTrackerOverview(this.scanGuid)
			this.trackerDomains = data.results
		},
		openTrackerDetails (event, domain) {
			const expansionOpen = event.currentTarget.classList.contains('v-expansion-panel-header--active')
			this.openDomain = domain
			if (!expansionOpen) {
				this.loadTrackersByDomain(domain)
			}
		},
		async loadTrackersByDomain (domain) {
			if (this.trackersByDomain[domain]) return
			const { data } = await getTrackerLookup(this.scanGuid, domain)
			this.$set(this.trackersByDomain, domain, data)
		},
		async updateOptions (options, domain) {
			const pageNumber = options.page
			const itemsPerPage = options.itemsPerPage === -1 ? this.trackersByDomain[domain].totalTrackers : options.itemsPerPage
			const orderDirection = options.sortDesc[0] ? 'desc' : 'asc'
			const sortByIndex = this.tableHeaders.findIndex(header => header.value === options.sortBy[0])
			const sortBy = sortByIndex === -1 ? 0 : sortByIndex
			const { data } = await getTrackerLookup(this.scanGuid, domain, itemsPerPage, pageNumber, sortBy, orderDirection)
			const trackerData = {
				...data,
				options
			}
			this.$set(this.trackersByDomain, domain, trackerData)
		}
	}
}
</script>
